export const JOBS_LOADING = "JOBS_LOADING";
export const GET_JOBS_CATEGORIES = "GET_JOBS_CATEGORIES";
export const REMOVE_JOBS_DATA = "REMOVE_JOBS_DATA";
